// src/utils/auth.ts

const TOKEN_KEY = 'token';
const EXPIRES_AT_KEY = 'expires_at';   // 存储过期时间戳（毫秒）

/**
 * 存储 token 和过期时间
 * @param token JWT token
 * @param expiresIn 有效期（秒），后端返回的秒数
 */
export function setToken(token: string, expiresIn: number) {
  localStorage.setItem(TOKEN_KEY, token);
  //const expiresAt = expiresIn * 1;
  localStorage.setItem(EXPIRES_AT_KEY, String(expiresIn));
}

/**
 * 获取 token
 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * 清除 token
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}

/**
 * 检查 token 是否已过期
 * @returns true 表示已过期或不存在
 */
export function isTokenExpired(): boolean {
  const expiresAt = localStorage.getItem(EXPIRES_AT_KEY);
  if (!expiresAt) return true;
  const t = Number(expiresAt)*1000;
  const result = Date.now() > t;

  //console.log("result:",result);
  return result
}
